import { Advisor } from '../types';

export const advisors: Advisor[] = [
  {
    id: 1,
    name: "Manish Bhagat",
    title: "Certified Financial Planner",
    experience: 12,
    specializations: ["Tax Planning", "Mutual Fund", "Wealth Manager"],
    location: "Bangalore",
    website: "https://flipcoininvestments.com/",
    bio: "Manish Bhagat specializes in comprehensive financial planning...",
    certifications: ["CA", "Mutual Fund"],
    phone: "+919740239199",
    email: "manishbhagat51@gmail.com",
    languages: ["Hindi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: true
  },
  {
    id: 2,
    name: "Disha Jain",
    title: "Certified Financial Planner",
    experience: 7,
    specializations: ["Tax Planning", "Mutual Fund", "Retirement Planning"],
    location: "Indore",
    website: "https://www.investingmymoney.co.in/",
    bio: "When I saw my sister (engineer) and her friends struggling with their tax and finance planning, I knew that I could provide value addition. Hence my journey started and now I have over 150 amazing clients....",
    certifications: ["CA", "SEBI Registered"],
    phone: "+919428826521",
    email: "djainofficial04@gmail.com",
    languages: ["Hindi", "English", "Gujarati"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: true
  },
  {
    id: 3,
    name: "Abhishek Kumar",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "New Delhi",
    website: "https://www.sahajmoney.com/",
    bio: "Abhishek Kumar, an IIM Bangalore Alumni, while working on his financial independence found it difficult to get honest advice for fixed fee as all he came across was complex and commission based financial advice. So in 2017, after attaining his financial independence, he started SahajMoney® after registering with SEBI to provide commission-free, transparent, and personalized financial advice.",
    certifications: ["MBA", "SEBI Registered"],
    phone: "+918861764646",
    email: "abhishekk@sahajmoney.com",
    languages: ["Hindi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 4,
    name: "Ajay Pruthi",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["Wealth Manager", "Mutual Fund", "Insurance"],
    location: "Mumbai",
    website: "https://plnr.in/",
    bio: "With PLNR, you get unbiased advice for your personal finances. Clean up your portfolio, choose the right financial product with tax efficiency, get a second opinion about your investments, define your goals and a way to achieve them with proper equity/debt allocation, all in the same place.",
    certifications: ["SEBI Registered"],
    phone: "+918860000332",
    email: "support@plnr.in",
    languages: ["Hindi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 5,
    name: "Akshay Nayak",
    title: "Certified Financial Planner",
    experience: 5,
    specializations: ["NRI Investments", "Mutual Fund", "Wealth Manager"],
    location: "Bangalore",
    website: "https://www.akshaynayakria.com/",
    bio: "I am a SEBI Registered Investment Advisor and Fee Only Financial Planner (Registration Number INA200014672) based in Bangalore. I offer comprehensive financial planning services to individuals for a flat annual fee. I have been practicing as an advisor and financial planner since May 2020. I hold an MBA in Finance from Great Eastern Management School, Bangalore (October 2017). I have been an independent investor since July 2017. ",
    certifications: ["NISM", "SEBI Licenced"],
    phone: "+919980909085",
    email: "akshayadv93@gmail.com",
    languages: ["Konkani", "Kannada", "Hindi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 6,
    name: "Avinash Luthria",
    title: "Certified Financial Planner",
    experience: 24,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "Bangalore",
    website: "https://fiduciaries.in/",
    bio: "I am an Hourly-Fee Financial Planner and SEBI Registered Investment Adviser with 24 years of experience, including a background as a senior Private Equity investor. I hold an MBA in Finance from IIM Bangalore and was the first to introduce the Hourly-Fee Financial Planning model in India. I exclusively recommend passive index funds to my clients, ensuring transparency and alignment of interests.I have engaged with over 100 high net worth client families. My approach is highly customized, and I do not have any team members to ensure a personalized experience for each client.",
    certifications: ["CFP", "SEBI Licenced"],
    phone: "",
    email: "avinash@fiduciaries.in  ",
    languages: ["Hindi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 7,
    name: "Basavaraj Tonagatti",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "Bangalore",
    website: "https://www.basunivesh.com/",
    bio: "I began my journey as a car mechanic and became a SEBI-registered financial planner. Starting out in Mumbai as a car mechanic, I gradually transitioned into the world of finance, inspired by mentors and a desire to help others. Through perseverance, I became a Certified Financial Planner and later a SEBI Registered Investment Advisor. Founding BasuNivesh allowed me to offer unbiased, fee-only financial planning, building trust through transparent and client-focused advice. Today, I am proud to be recognized for my writing and dedication to empowering individuals in their financial journeys.",
    certifications: ["SEBI Registered"],
    phone: "+916361835871",
    email: "basunivesh@gmail.com",
    languages: ["Kannada", "Hindi"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 8,
    name: "Brijesh Vappala",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["NRI Investments", "Mutual Fund", "Wealth Manager"],
    location: "Palakkad",
    website: "https://bvare.com/",
    bio: "I am Brijesh Vappala, founder of BVare Financial Planners and a Certified Financial Planner. With 19 years in financial services, I’ve worked across India and the UK. I started BVare in 2017 to offer unbiased, fee-only financial advice. I serve clients in India and abroad, mainly IT professionals, doctors, and marine engineers.",
    certifications: ["CFP", "SEBI Registered"],
    phone: "+919961023640",
    email: "brijesh@bvare.com",
    languages: ["Malayalam", "Hindi", "Tamil", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 9,
    name: "Chandan Singh Padiyar",
    title: "Certified Financial Planner",
    experience: 10,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "Pune",
    website: "https://padiyars.com/",
    bio: "We specialize in providing unbiased financial planning solutions by giving utmost priority to the interest of the client. We help clients in designing a plan for achieving their life goals in a simplistic manner by helping them prepare a personalized comprehensive financial plan and guiding them in implementing the same. We follow a very robust mechanism to derive solutions for every financial problem.",
    certifications: ["CFP", "SEBI Registered"],
    phone: "+917385612442",
    email: "cspadiyar@gmail.com",
    languages: ["Hindi", "Marathi", "Kumaoni"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 10,
    name: "Dhilip Krishna",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["Wealth Manager", "Retirement Planning", "Insurance"],
    location: "Chennai",
    website: "https://www.indexinvesting.in/home.php",
    bio: "I have been a Fund Manager of a Mutual Fund and the Chief Investment Officer of an insurance company. With 15 years in investment management and an MBA from IIM Bangalore, I bring deep expertise to the table. My experience has shown me what it takes to manage wealth effectively. Now, I want to serve as the CIO for your family, guiding you at every stage of your financial journey.",
    certifications: ["MBA", "SEBI Registered"],
    phone: "+919769497239",
    email: " dhilipkrishna@indexinvesting.in",
    languages: ["Hindi", "Tamil", "Malayalam"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 11,
    name: "Gursimran Singh",
    title: "Certified Financial Planner",
    experience: 20,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "New Delhi",
    website: "https://paramasa.com/",
    bio: "I am Gursimran Singh, a fee-only SEBI Registered Investment Advisor with over 20 years of corporate experience. My passion for investing and personal finance began in my childhood, managing my father’s business treasury. I believe in providing unbiased, commission-free financial advice tailored to each client’s needs. My goal is to offer transparent, personalized guidance to help you achieve lasting financial well-being.",
    certifications: ["MBA", "SEBI Registered"],
    phone: "+919099917772",
    email: "contact@paramasa.com",
    languages: ["Hindi", "Punjabi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 12,
    name: "Jay Sheth",
    title: "Certified Financial Planner",
    experience: 20,
    specializations: ["Wealth Manager", "Retirement Planning", "Insurance"],
    location: "Mumbai",
    website: "https://www.shwealth.in/",
    bio: "I am Jay Sheth, an MBA in Finance from the USA and a Chartered Accountant from the UK. With over 20 years of experience in finance, consultancy, and business, I have worked with leading firms like Deloitte and KPMG. My expertise spans advising clients across income levels and geographies, including India and the USA. I am dedicated to delivering research-backed, personalized financial advice tailored to each client’s unique needs.",
    certifications: ["MBA", "CA", "SEBI Registered"],
    phone: "+918369460917",
    email: "jay@shwealth.in",
    languages: ["Hindi", "Gujarati", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 13,
    name: "Preeti Zende",
    title: "Certified Financial Planner",
    experience: 10,
    specializations: ["Wealth Manager", "Retirement Planning", "Insurance"],
    location: "Mumbai",
    website: "https://apanadhan.com/",
    bio: "At Apana Dhan, we understand your needs for financial planning. We offer Fee-only Financial Planning services. We are committed to your goals and hence to avoid any conflicts of interest, we are not into the distribution of any financial products. Hence our only earning is from the fees we charge to our clients.",
    certifications: ["SEBI Registered"],
    phone: "+919833310722",
    email: "preetikz@gmail.com",
    languages: ["Hindi", "Marathi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 14,
    name: "Priyadarshini Mulye",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "Ratnagiri",
    website: "http://www.arthafinplan.com/",
    bio: "Artha FinPlan, a SEBI-registered, is a fee-only financial planning firm. I provide unbiased, personalized advice to help clients achieve their financial goals. My approach is transparent, ethical, and always puts the client first. Based in Thane and Ratnagiri, I serve clients across India and abroad.",
    certifications: ["MBA", "CPA", "SEBI Registered"],
    phone: "+919769935011",
    email: "priya@arthafinplan.com",
    languages: ["Hindi", "Marathi", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 15,
    name: "Upasana Mondal",
    title: "Certified Financial Planner",
    experience: 15,
    specializations: ["Wealth Manager", "Mutual Fund", "Retirement Planning"],
    location: "Goa",
    website: "https://www.dreamblueprintz.com/",
    bio: "I am a Certified Financial Planner (CFP) which is awarded by Financial Planning and Standards Board, India. A fellow of Insurance Institute of India, (FIII) recognized by Govt. of India, IRDA and insurers in India and abroad and an MBA. Worked on more than 500 financial plans since 2011.",
    certifications: ["MBA", "SEBI Registered"],
    phone: "+919818555764",
    email: "upasana@dreamblueprintz.com",
    languages: ["Hindi", "Bengali"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 16,
    name: "Sudheer Variar M",
    title: "Certified Financial Planner",
    experience: 25,
    specializations: ["Wealth Manager", "Retirement Planning", "Insurance"],
    location: "Bangalore",
    website: "https://prasidhi.in/index.html",
    bio: "I am a SEBI Registered Investment Advisor and a fixed fee financial planner based in Bangalore. I offer truly independent, commission-free advice to help clients worldwide achieve their financial goals. My approach is rooted in objectivity, integrity, and transparency. I am dedicated to empowering people with financial knowledge so they can make confident, informed decisions.",
    certifications: ["CFP", "SEBI Registered"],
    phone: "+919620177540",
    email: "sudheer@prasidhi.in",
    languages: ["Malayalam", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 17,
    name: "Vikram Krishnamoorthy",
    title: "Certified Financial Planner",
    experience: 11,
    specializations: ["NRI Investments", "Mutual Fund", "Wealth Manager"],
    location: "Coimbatore",
    website: "https://www.insightful.in/",
    bio: "Since 2014, we have been providing Professional Financial Planning, Investment Advisory and Wealth Management services to individuals and families. Although based in Coimbatore, India, 95% of our clients are from other cities like Chennai, Bangalore, as well as numerous NRIs across the globe. Our mission is to help you realize your financial goals by understanding your unique needs, identifying and educating you on all the options available so you can make fully informed financial decisions.",
    certifications: ["MBA", "CFP"],
    phone: "",
    email: "info@insightful.in",
    languages: ["Tamil", "Telugu", "English"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: false
  },
  {
    id: 18,
    name: "Aditya Agrawal",
    title: "Certified Financial Planner",
    experience: 30,
    specializations: ["Tax Planning", "Mutual Fund", "Retirement Planning"],
    location: "Bangalore",
    website: "https://wealthy.in/partners/adit",
    bio: "Aditya Agrawal helps you make money with your mind, not your time. As a trusted PMS and MF distributor, I provide expert guidance for wealth creation, financial planning, term and health insurance and secure investments. Tailored strategies for your financial success. Start building your future today!",
    certifications: ["CA", "SEBI Registered"],
    phone: "918073961238",
    email: "adit.agrawal@gmail.com",
    languages: ["Hindi", "English", "Marwari", "Bangalore"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: true
  },
  {
    id: 19,
    name: "Munish Chauhan",
    title: "Certified Financial Planner",
    experience: 22,
    specializations: ["Tax Planning", "Mutual Fund", "Retirement Planning"],
    location: "Gurgaon",
    website: "www.finclu.app",
    bio: "Munish Chauhan is a Financial Freedom Specialist with over 22 years of experience. He manages portfolios for 120+ families and has educated 1,000+ people on personal finance. Munish holds the Certified Financial Planner™ (CFP®) credential from FPSB, USA. He is dedicated to helping families achieve financial well-being with a client-first, ethical approach.",
    certifications: ["MBA", "CFP"],
    phone: "919815946442",
    email: "munish.chauhan@finclu.app",
    languages: ["Hindi", "English", "Punjabi"],
    rating: 0,
    reviewCount: 0,
    hourlyRate: 0,
    image: '',
    featured: true
  },
  
];
